import React from 'react'
import { connect } from 'react-redux';
import { IUser } from '../../../../Utils/types';
import {
  languageSelector,
  setLanguage
} from '../../../../Redux/Reducers/settingsReducer';
import { userSelector } from '../../../../Redux/Reducers/userReducer';
import classes from './ProfilePage.module.scss';
import { localization } from '../../../../Utils/Localization/localization';
import { Button, Select } from 'antd';
import { logOut } from '../../../../Redux/Reducers/authReducer';
import {
  userStatusSelector,
  getProfile
} from '../../../../Redux/Reducers/userReducer';
import { Admins } from './Admins';

interface StateProps {
  language: string,
  user: IUser,
  status: string
}
interface DispatchProps {
  logOut: () => void,
  setLanguage: (value: string) => void,
  getProfile: () => void
}
interface Props extends StateProps, DispatchProps { }

function ProfilePage(props: Props) {

  React.useEffect(() => {
    props.getProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.ProfilePage}>
      {
        props.status === 'loaded'
          ? <div className={classes.Profile}>
            <img src={props.user.avatar} alt="Avatar" />
            <p>{localization('email', props.language)}: {props.user.email}</p>
            <p>{localization('level', props.language)}: {props.user.level}</p>
            <div className={classes.Btns}>
              <div className={classes.Language}>
                <span>
                  {localization('language', props.language)}
                </span>
                <Select
                  defaultValue={props.language}
                  onChange={(value) => props.setLanguage(value)}
                >
                  <Select.Option value={'ru'}>ru</Select.Option>
                  <Select.Option value={'en'}>en</Select.Option>
                </Select>
              </div>
              <Button
                type={'danger'}
                onClick={props.logOut}
              >
                {localization('logOut', props.language)}
              </Button>
            </div>
          </div>
          : localization('wait', props.language)
      }
      <Admins
        currentUserId={props.user.id}
        currentUserLevel={props.user.level}
      />
    </div>
  );
}

function mapStateToProps(state: any) {
  return {
    language: languageSelector(state),
    user: userSelector(state),
    status: userStatusSelector(state)
  }
}
const mapDispatchToProps = {
  logOut,
  setLanguage,
  getProfile
}

const ConnectedProfilePage = connect(mapStateToProps, mapDispatchToProps)(ProfilePage);
export { ConnectedProfilePage as ProfilePage };